import { useEffect,useCallback } from "react";
import { useSelector } from "react-redux";
import { setFavicon } from "./utils/react-ec-utils";
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: any[]) => void;
  }
}

interface AppProps {
  restaurantDetails?: {
    uiFeatureFlags?: {
      googleTag?: string;
    };
  };
}
const CommonTheme = () => {
  const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );
  const colorFromLocalStorage = localStorage.getItem('theme')
  const getImageURL =
    (type: string) => {
      if (restaurantDetails && restaurantDetails?.media?.length > 0) {
        const logoMedia =
          restaurantDetails &&
          restaurantDetails?.media?.filter((media: any) => media?.entityType == type)[0];

        return (
          logoMedia?.mimeType &&
          process.env.REACT_APP_IMAGE_URL +
            logoMedia?.mimeType.split('/')[0] +
            '/' +
            logoMedia?.id +
            '.' +
            logoMedia?.mimeType.split('/')[1]
        );
      } else {
        return '';
      }
    }
 useEffect(() => {
  const ID=restaurantDetails?.uiFeatureFlags?.googleTag
    if (!ID) return;

    // If script already exists, don't add again
    if (!document.querySelector<HTMLScriptElement>(
      `script[src*="googletagmanager.com/gtag/js?id=${ID}"]`
    )) {
      
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
      document.head.appendChild(script);
    }

    // Initialize gtag only once
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments as unknown as Record<string, unknown>);
    };
    console.log(document.querySelector<HTMLScriptElement>(`script[src*="googletagmanager.com/gtag/js?id=${ID}"]`))
    window.gtag("js", new Date());
    window.gtag("config", ID);
  }, [restaurantDetails,restaurantDetails?.uiFeatureFlags?.googleTag]);
 

  useEffect(() => {

    const themeColor =

      restaurantDetails?.themeColor?.primaryColor ?
      restaurantDetails?.themeColor?.primaryColor :
      restaurantDetails?.theme?.primaryColor ?
      restaurantDetails?.theme?.primaryColor :
      colorFromLocalStorage ? colorFromLocalStorage : "#E52333"; // returns red if undefined
      const themeTextColor = restaurantDetails?.themeColor?.textColor ?
      restaurantDetails?.themeColor?.textColor :
      restaurantDetails?.theme?.textColor ? 
      restaurantDetails?.theme?.textColor : "#FFFFFF"
      document.documentElement.style.setProperty("--primary-color", themeColor);
      document.documentElement.style.setProperty("--primary-text-color", themeTextColor);
      document.documentElement.style.setProperty("--secondary-color", themeTextColor);
       const logoUrl = (getImageURL("META") || getImageURL("META") === '') ? getImageURL("META") : getImageURL("LOGO")
      // if no restaurant logo, use default Brisque logo from public folder
      setFavicon(logoUrl || "/favicon.svg");

  }, [restaurantDetails?.themeColor?.primaryColor, restaurantDetails?.themeColor?.textColor,restaurantDetails]);

  return null;
};

export default CommonTheme;
